import React from 'react';
import { Container } from '@mui/material';

const Base = (props) => {
    return(
        <React.Fragment>
            <Container maxWidth= {false} disableGutters>
                {props.children}
            </Container>
        </React.Fragment>
    )
}

export default Base;